import { useReq } from '@app/request';
import { useMemo } from 'react';
import { useCookies } from 'react-cookie';

const useDeviceId = () => {
  const req = useReq();
  const [cookies] = useCookies(['stockx_device_id']);

  return useMemo(() => {
    if (req?.stockx_device_id) {
      return req.stockx_device_id;
    }

    if (cookies?.stockx_device_id) {
      return cookies?.stockx_device_id;
    }

    return 'web-anon-user';
  }, [cookies?.stockx_device_id, req?.stockx_device_id]);
};

export default useDeviceId;
